import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Frlanguage from './locale/fr.json';
import ARlanguage from './locale/ar.json';

const resources = {
  fr: {
    translation: Frlanguage
  },
  ar: {
    translation: ARlanguage
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',

    interpolation: {
      escapeValue: false
    },
    react: { useSuspense: false }
  });

export default i18n;
